import { pushToDataLayer } from '@domain-group/fe-helper';
import { sendToMixpanel } from '..';

interface TrackContentCarouselCtaOptions {
  carouselName: string;
  carouselTitle: string;
  interactionCTA: string;
}

const trackContentCarouselCta = ({
  carouselName,
  carouselTitle,
  interactionCTA,
}: TrackContentCarouselCtaOptions): void => {
  sendToMixpanel('Tap Content Carousel Header CTA', {
    siteSection: 'Agents',
    carouselName,
    carouselTitle,
    interactionCTA,
  });

  pushToDataLayer({
    event: 'cta_driver',
    element_list_name: carouselName,
    element_title: carouselTitle,
    element_text: interactionCTA,
    element_list_position: '',
    element_target_category_primary: 'Content',
    element_target_page_type: 'Article',
    element_type: 'text link',
  });
};

export default trackContentCarouselCta;
